import type { LayoutItem } from 'react-grid-layout';
import type { Component, DataEntryComponent, PageTemplateConfig } from '../../../../api/pages-client/pages-client.type';

enum ObjectType {
  Portfolio = 'portfolio',
  Project = 'project',
  Board = 'board',
  Sprint = 'sprint',
  Initiative = 'initiative',
}

type ObjectKeyInfo = {
  key: string;
  objectType: ObjectType;
  usedInComponents: string[];
};

type PendingSave = {
  nextConfig: PageTemplateConfig;
  nextComponents: Component[];
  nextDataEntryComponents: DataEntryComponent[];
  nextLayout: LayoutItem[];
};

type SaveTemplateBanner = {
  color: 'green' | 'red';
  text: string;
};

export { ObjectType };
export type { ObjectKeyInfo, PendingSave, SaveTemplateBanner };
